<template>
  <div class="grid-container">
    <div class="grid-x title-row">
      <div class="small-7 cell">
        <h2 class="page-title">
          {{ industrySubtitle }}
        </h2>
        <h2
          v-if="pageHasApplicationCount"
          class="application-count"
        >
          ({{ totalApplications }} Applications)
        </h2>
      </div>
      <div class="small-5 cell">
        <rare-date-picker
          @datePickerApplyClicked="updateCharts"
        />
      </div>
    </div>

    <rare-divider />

    <div class="grid-x control-row">
      <div class="small-6 cell">
        <div class="label">
          Industry <span v-if="isNotPITab">Average</span>
        </div>
        <rare-industry-select
          @industryAverageChange="updateCharts"
        />
      </div>
      <div class="small-6 cell text-right">
        <div style="float: right">
          <rare-data-format-switch
            @updateDataFormat="renderCharts"
          />
        </div>
        <div style="float: right">
          <div class="label">
            View Applicants by
          </div>
        </div>
      </div>
    </div>

    <rare-divider />
  </div>
</template>

<script>
import RareDivider from '../layout/RareDivider.vue';
import RareDatePicker from './RareDatePicker.vue';
import RareDataFormatSwitch from './RareDataFormatSwitch.vue';
import RareIndustrySelect from './RareIndustrySelect.vue';

export default {
  name: 'RareControlPanel',
  components: {
    'rare-divider': RareDivider,
    'rare-industry-select': RareIndustrySelect,
    'rare-date-picker': RareDatePicker,
    'rare-data-format-switch': RareDataFormatSwitch,

  },
  data() {
    return {
      clientByIndustryLists: [],
    };
  },
  computed: {
    isDataLoaded() {
      // This part is to only mount the router view once we've finished
      // populating the client list and ind comp lists.
      return this.$store.state.buildIndustryClientList;
    },
    pageHasApplicationCount() {
      return ['Summary', 'PerformanceIndex', 'IndustryOverview'].includes(this.currentPage);
    },
    totalApplications() {
      let total = 0;
      if (this.$store.getters.comparisonMode === 'date') {
        total = this.$store.getters.totalApplicationsTotal;
      } else {
        total = this.$store.getters.totalApplicationsBase;
      }
      return total;
    },
    currentClient() {
      return this.$store.getters.currentClientDisplayName;
    },
    industryAverage() {
      return this.$store.getters.industryAverageLabel(this.$store.getters.industryAverage);
    },
    isNotPITab() {
      return this.$route.name !== 'PerformanceIndex';
    },
    currentPage() {
      return this.$route.name;
    },
    industrySubtitle() {
      const mode = this.$store.getters.clientOrRareMode;
      switch (this.currentPage) {
        case 'Summary':
          return 'Summary';
        case 'PerformanceIndex':
          return 'Performance Index';
        case 'IndustryOverview':
          return mode === 'rare' ? 'Client Overview' : 'Industry Overview';
        default:
          break;
      }
      return '';
    },
  },
  updated() {
    this.clientByIndustryLists = this.$store.clientByIndustryLists;
  },
  mounted() {
    this.clientByIndustryLists = this.$store.clientByIndustryLists;
  },
  methods: {
    updateCharts() {
      this.$store.commit('updateCurrentParamsHash');
      this.$root.$emit('updateCharts', true);
    },
    renderCharts() {
      this.$root.$emit('renderCharts', true);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .title-row {
    margin-top: 40px;
    margin-bottom: 10px;
  }

  .control-row {
    margin-top: 17px;
    margin-bottom: 3px;
  }

  .label {
    margin-right: 20px;
    margin-top: 10px
  }

</style>
